import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { TranslateService } from '@ngx-translate/core';

import { ToastService } from '../../../../services/toast.service';
import { HttpStatus } from 'app/shared.constants/all-constants';
import { SKILL_API_BASE } from '../constants/skill-api.constants';

const ERROR_MESSAGES = {
  FORBIDDEN: 'SKILL_LEARNING_INTERCEPTOR_FORBIDDEN',
  NOT_FOUND: 'SKILL_LEARNING_INTERCEPTOR_NOT_FOUND',
  CONFLICT: 'SKILL_LEARNING_INTERCEPTOR_CONFLICT',
  PRECONDITION_FAILED: 'SKILL_LEARNING_INTERCEPTOR_PRECONDITION_FAILED',
  TOO_MANY_REQUESTS: 'SKILL_LEARNING_INTERCEPTOR_TOO_MANY_REQUESTS',
  SERVICE_UNAVAILABLE: 'SKILL_LEARNING_INTERCEPTOR_SERVICE_UNAVAILABLE',
};
const PROBATION_RESOURCE_PATTERN = /\/api\/v2\/users\/[^/]+\/probation(?:\?|$)/;
const ONBOARDING_RESOURCE_PATTERN = /\/api\/v2\/users\/me\/onboarding(?:\/complete)?(?:\?|$)/;
const READ_METHOD = 'GET';
const INDEX_NOT_FOUND = -1;

@Injectable()
export class SkillLearningHttpInterceptor implements HttpInterceptor {

  constructor(
    private toastService: ToastService,
    private injector: Injector,
  ) {}

  intercept(request: HttpRequest<Object>, next: HttpHandler): Observable<HttpEvent<Object>> {
    if (!this.isSkillApiRequest(request)) {
      return next.handle(request);
    }
    return next.handle(request).catch(error => this.handleSkillApiError(request, error));
  }

  private isSkillApiRequest(request: HttpRequest<Object>): boolean {
    return request.url.indexOf(SKILL_API_BASE) !== INDEX_NOT_FOUND
      && !ONBOARDING_RESOURCE_PATTERN.test(request.url);
  }

  private handleSkillApiError(request: HttpRequest<Object>, error: HttpErrorResponse): Observable<never> {
    if (!(error instanceof HttpErrorResponse)) {
      return Observable.throw(error);
    }
    if (!this.isOptionalProbationAccessDenied(request, error)) {
      this.notifyUserAboutError(error);
    }
    return Observable.throw(error);
  }

  private isOptionalProbationAccessDenied(request: HttpRequest<Object>, error: HttpErrorResponse): boolean {
    return error.status === HttpStatus.FORBIDDEN
      && request.method === READ_METHOD
      && PROBATION_RESOURCE_PATTERN.test(request.url);
  }

  private notifyUserAboutError(error: HttpErrorResponse): void {
    switch (error.status) {
      case HttpStatus.FORBIDDEN:
        this.toastService.error(this.translateMessage(ERROR_MESSAGES.FORBIDDEN)); break;
      case HttpStatus.NOT_FOUND:
        this.toastService.error(this.translateMessage(ERROR_MESSAGES.NOT_FOUND)); break;
      case HttpStatus.CONFLICT:
        this.toastService.warning(this.translateMessage(ERROR_MESSAGES.CONFLICT)); break;
      case HttpStatus.PRECONDITION_FAILED:
        this.toastService.warning(this.translateMessage(ERROR_MESSAGES.PRECONDITION_FAILED)); break;
      case HttpStatus.TOO_MANY_REQUESTS:
        this.toastService.warning(this.translateMessage(ERROR_MESSAGES.TOO_MANY_REQUESTS)); break;
      case HttpStatus.SERVICE_UNAVAILABLE:
        this.toastService.error(this.translateMessage(ERROR_MESSAGES.SERVICE_UNAVAILABLE)); break;
    }
  }

  private translateMessage(key: string): string {
    return this.injector.get(TranslateService).instant(key);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/interceptors/skill-learning-http.interceptor.ts